/** 発送予定詳細の運送便選択肢 */
export const TRANSPORT_SERVICE_OPTIONS = [
  '西濃・瑞穂',
  '西濃・資材倉庫',
  'エスライン・瑞穂',
  'エスライン・資材倉庫',
  '宝・引取',
  '製品と同送',
  '型枠と同送',
  '営業便',
  '瑞穂倉庫渡し',
  'その他',
];
